// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"0d3e9cf6","69":"956d5c52","199":"67bffe27","423":"40b50055","461":"b6e32793","557":"e50f43b8","626":"ed7ce0a7","653":"da269179","832":"7aa62abd","925":"7e442a70","973":"1214b641"}[chunkId] + ".chunk.js";
};